import { memo } from 'react';

import { ScArrowNext, ScArrowPrev } from './styled';

interface IInsideArrows {
  visibleForMobile?: boolean;
  isBeginning: boolean;
  isEnd: boolean;
  dark?: boolean;
  handlePrevClick: () => void;
  handleNextClick: () => void;
  hideArrows: boolean;
  insetLeftArrow?: string;
  insetRightArrow?: string;
  loop?: boolean;
  isOne?: boolean;
}

export const InsideArrows = memo(
  ({
    loop,
    visibleForMobile,
    insetRightArrow,
    insetLeftArrow,
    handlePrevClick,
    handleNextClick,
    isBeginning,
    isEnd,
    hideArrows,
    isOne,
  }: IInsideArrows) => {
    if (isOne) return null;
    return (
      <>
        <ScArrowPrev
          onClick={handlePrevClick}
          hide={hideArrows || (!loop && isBeginning)}
          visibleForMob={visibleForMobile}
          inset={insetLeftArrow}
          aria-label="arrow left"
        />
        <ScArrowNext
          onClick={handleNextClick}
          hide={hideArrows || (!loop && isEnd)}
          visibleForMob={visibleForMobile}
          inset={insetRightArrow}
          aria-label="arrow right"
        />
      </>
    );
  }
);
